import './LtrScoreCp.scss';
import TrendingDownIcon from '../../../../assets/images/Trending Down Icon.svg';
import TrendingUpIcon from '../../../../assets/images/Trending Up Icon.svg';
import { useNavigate } from 'react-router-dom';
import { useGetLtrScore } from '../api/get-ltr-score';
import { Tooltip } from 'devextreme-react';

export default function LtrScoreCp() {
	const navigate = useNavigate();
	const recordData = useGetLtrScore();

	let currentAverage = Math.trunc(recordData.data?.currentAverage ?? 0);
	let previousAverage = Math.trunc(recordData.data?.previousAverage ?? 0);
	let difference = currentAverage - previousAverage;

	return (
		<div id="ltrScoreCp" className={`ltr-square ${currentAverage > previousAverage ? 'positive' : 'negative'}`} onClick={(e) => { 
			navigate('/cfi/metrics/CFIAvgLTRScores');
		}}>
			<div className='ltr-square-ltr'>LTR</div>
			<div className={`ltr-square-center`}>
				<img className='ltr-image' src={currentAverage > previousAverage ? TrendingUpIcon : TrendingDownIcon} alt="Icon" />&nbsp;
				<span>{currentAverage}%</span>
			</div>
			<Tooltip
				target="#ltrScoreCp"
				showEvent="mouseenter"
				hideEvent="mouseleave"
				position="left"
				hideOnOutsideClick={true}
			>
				<div>Current Score: <span style={{fontWeight: 'bold'}}>{currentAverage}%</span></div>
				<div>Previous Score: <span style={{fontWeight: 'bold'}}>{previousAverage}%</span></div>
				<div style={{color: `${currentAverage > previousAverage ? '#7df591': '#f59a9a'}`}}>{difference} points {currentAverage > previousAverage ? 'increase' : 'decrease'}</div>
			</Tooltip>
        </div>
	)
}